import { render, staticRenderFns } from "./shopQrCode.vue?vue&type=template&id=55c24f66&scoped=true"
import script from "./shopQrCode.vue?vue&type=script&lang=js"
export * from "./shopQrCode.vue?vue&type=script&lang=js"
import style0 from "./shopQrCode.vue?vue&type=style&index=0&id=55c24f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c24f66",
  null
  
)

export default component.exports